import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import ModalTrigger from '../common/ModalTrigger';
import { getRequest, putRequest } from '../../requestUtils';
var formatError = function formatError(error) {
  return error ? /*#__PURE__*/React.createElement("p", {
    className: "error-text"
  }, error) : '';
};
function MenuList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(components.MenuList, props, Array.isArray(children) ? children.slice(0, 10) : children);
}
MenuList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node)
};
var CompanyMerge = /*#__PURE__*/function (_React$Component) {
  function CompanyMerge(props) {
    var _this;
    _classCallCheck(this, CompanyMerge);
    _this = _callSuper(this, CompanyMerge, [props]);
    _this.state = {};
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }
  _inherits(CompanyMerge, _React$Component);
  return _createClass(CompanyMerge, [{
    key: "companyOptions",
    value: function companyOptions(term) {
      var mergeCompanyId = this.props.mergeCompanyId;
      return getRequest('/companies/autocomplete_dropdown', {
        term: term,
        show_all: true,
        limit: 50
      }).then(function (response) {
        return response.data.filter(function (company) {
          return company.id !== mergeCompanyId;
        }).map(function (i) {
          return {
            label: i.domain ? "".concat(i.name, " <").concat(i.domain, ">") : i.name,
            value: i.id,
            resource_id: i.resource_id
          };
        });
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(val) {
      this.setState({
        selectedCompany: val
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        mergeCompanyId = _this$props.mergeCompanyId,
        csrfToken = _this$props.csrfToken;
      var selectedCompany = this.state.selectedCompany;
      putRequest('/companies/merge', {
        to_keep_id: selectedCompany.value,
        to_merge_id: mergeCompanyId
      }, csrfToken).then(function () {
        window.location = "/companies/".concat(selectedCompany.resource_id);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        companyName = _this$props2.companyName,
        error = _this$props2.error;
      var selectedCompany = this.state.selectedCompany;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Merge ".concat(companyName, "..."),
        buttonStyles: "secondary",
        submitButtonText: "Merge",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleSubmit,
        closeAfterSubmit: true,
        idKey: "merge-company-modal"
      }, /*#__PURE__*/React.createElement("h2", null, "Merge ".concat(companyName, " to:")), /*#__PURE__*/React.createElement("div", {
        id: "company-dropdown",
        className: "company-select",
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(AsyncSelect, {
        id: "company",
        className: "company-select-dropdown ".concat(error ? 'error' : ''),
        name: "user[company_user_attributes][company_attributes][name]",
        classNamePrefix: "company-select",
        loadOptions: function loadOptions(input) {
          return _this2.companyOptions(input);
        },
        defaultOptions: true,
        placeholder: "Company Name",
        onChange: this.handleSelect,
        value: selectedCompany,
        components: {
          MenuList: MenuList,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      }), formatError(error)));
    }
  }]);
}(React.Component);
CompanyMerge.propTypes = {
  error: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  mergeCompanyId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired
};
CompanyMerge.defaultProps = {
  error: null
};
export default CompanyMerge;